import React from 'react'
import Heading from 'components/ui/heading'
import styles from './index.module.css'

type Props = {
  title: string
  description?: React.ReactNode
  children?: React.ReactNode
}

/**
 * A section component for pages that displays a title, optional description, and content
 * @param title - The section title to display as a heading
 * @param description - Optional description content to display below the title
 * @param children - Optional content to display in the section body
 * @returns Page section with header containing title/description and optional content area
 */
const PageSection = ({ title, description, children }: Props) => (
  <div className={styles.pageSection}>
    <div className={styles.pageSectionHeader}>
      <Heading size="500">{title}</Heading>
      {description}
    </div>
    {children && <div className={styles.pageSectionContent}>{children}</div>}
  </div>
)

export default PageSection
